module.exports = __webpack_public_path__ + "static/media/yegou.f17ec1fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/yegou.png
// module id = 218
// module chunks = 0